export default __webpack_public_path__ + "static/media/Image_7.27cb6e86.png";